import Vue from 'vue';
import moment from 'moment';

export class AbstractModel {
    endpoint = '';

    get(requestOptions) {
        return Vue.$explorer.makeRequest(`/api/${this.endpoint}`, 'GET', requestOptions);
    }

    getOne(id, requestOptions) {
        return Vue.$explorer.makeRequest(`/api/${this.endpoint}/${id}`, 'GET', requestOptions);
    }

    create(requestOptions) {
        return Vue.$explorer.makeRequest(`/api/${this.endpoint}`, 'POST', requestOptions);
    }

    update(id, requestOptions) {
        return Vue.$explorer.makeRequest(`/api/${this.endpoint}/${id}`, 'PUT', requestOptions);
    }

    patch(id, requestOptions) {
        return Vue.$explorer.makeRequest(`/api/${this.endpoint}/${id}`, 'PATCH', requestOptions);
    }

    patchList(requestOptions) {
        return Vue.$explorer.makeRequest(`/api/${this.endpoint}`, 'PATCH', requestOptions);
    }

    delete(id, requestOptions) {
        return Vue.$explorer.makeRequest(`/api/${this.endpoint}/${id}`, 'DELETE', requestOptions);
    }

    getDateObject(date) {
        return moment.utc(date, 'YYYY-MM-DD HH:mm').toDate();
    }
}
